/* tslint:disable */
import './404';
import './agent';
import './almond';
import './auction';
import './back-top';
import './banner';
import './battery';
import './bug';
import './building';
import './chart';
import './clipboard';
import './component';
import './dashboard';
import './discount';
import './documentation';
import './drag';
import './edit';
import './education';
import './email';
import './example';
import './excel';
import './exit-fullscreen';
import './eye-off';
import './eye-on';
import './form';
import './fullscreen';
import './globe';
import './guide-2';
import './guide';
import './hamburger';
import './icon';
import './inr';
import './international';
import './language';
import './like';
import './link';
import './list';
import './location';
import './lock';
import './message';
import './money';
import './nested';
import './password';
import './pdf';
import './people';
import './peoples';
import './qq';
import './riyal';
import './sack';
import './scale';
import './search';
import './shopping';
import './size';
import './skill';
import './star';
import './support';
import './tab';
import './table';
import './tax';
import './theme';
import './tree-table';
import './tree';
import './truck';
import './user';
import './wechat';
import './zip';